import { render } from "./ErrorAlert.vue?vue&type=template&id=633f12ce&scoped=true&ts=true"
import script from "./ErrorAlert.vue?vue&type=script&lang=ts"
export * from "./ErrorAlert.vue?vue&type=script&lang=ts"

import "./ErrorAlert.vue?vue&type=style&index=0&id=633f12ce&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633f12ce"]])

export default __exports__